import { render, staticRenderFns } from "./commerceClassroom.vue?vue&type=template&id=1f4d37e9&scoped=true&"
import script from "./commerceClassroom.vue?vue&type=script&lang=js&"
export * from "./commerceClassroom.vue?vue&type=script&lang=js&"
import style0 from "./commerceClassroom.vue?vue&type=style&index=0&id=1f4d37e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4d37e9",
  null
  
)

export default component.exports